export default __webpack_public_path__ + "static/media/Grimwrest.54b0c1ab.jpg";